export default {
  form: {
    name: '名前',
    placeholder: '入力',
    nameEmptyWarning: '名前は空白にできません',
  },
}
